import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EFonts } from 'libs/styles/styling';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    onReset: () => void;
}

export const EventFormSubmitted = (props: Props) => {
    return (
        <S_EventFormSubmitted className={props.className}>
            <S_IconContainer>
                <S_Icon icon={['fas', 'check-circle']} />
            </S_IconContainer>
            <S_Text>{Localization.FORM_SUBMITTED}</S_Text>

            <S_ThankYouNote>{}</S_ThankYouNote>
            <S_SubmitAgain
                onClick={() => {
                    props.onReset();
                }}
            >
                {Localization.SUBMIT_AGAIN}
            </S_SubmitAgain>
        </S_EventFormSubmitted>
    );
};

const S_EventFormSubmitted = styled.div`
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const S_Text = styled.div`
    margin-bottom: 25px;
    font-family: ${EFonts.Medium};
    line-height: 1.4em;
`;

const S_ThankYouNote = styled.div`
    font-family: ${EFonts.Medium};
    font-size: 15px;
    max-width: 250px;
`;

const S_SubmitAgain = styled.div`
    margin-top: 8px;
    align-self: flex-end;
    text-decoration: underline;
    font-family: ${EFonts.Regular};
    padding: 5px;
    font-size: 14px;
`;

const S_IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 60px;
    color: #64ae62;
    margin-bottom: 20px;
`;
